import { motion } from "framer-motion";
import {
  Sparkles,
  Compass,
  Layers,
  Anchor,
  Rocket,
  Globe,
  Lightbulb,
  Target,
} from "lucide-react";
import { landing } from "@/lib/mockData";

const ICONS = [Compass, Anchor, Rocket, Globe, Lightbulb, Target, Layers, Sparkles];

export default function SocialProofStrip() {
  const logos = [...landing.socialProof, ...landing.socialProof]; // duplicate for seamless loop

  return (
    <section
      data-testid="social-proof"
      className="overflow-hidden border-y border-black/[0.04] bg-white/40 py-12"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div
          data-testid="social-proof-eyebrow"
          className="text-center text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500"
        >
          Trusted by 1,200+ founders building their next venture
        </div>
        <div className="mt-8 overflow-hidden">
          <motion.div
            animate={{ x: ["0%", "-50%"] }}
            transition={{ duration: 40, repeat: Infinity, ease: "linear" }}
            className="flex w-max items-center gap-12"
          >
            {logos.map((name, idx) => {
              const Icon = ICONS[idx % ICONS.length];
              return (
                <div
                  key={`${name}-${idx}`}
                  data-testid={`social-logo-${idx}`}
                  className="flex flex-shrink-0 items-center gap-2 text-zinc-400"
                >
                  <Icon className="h-5 w-5" strokeWidth={2.2} />
                  <span className="text-[22px] font-extrabold tracking-tight">
                    {name}
                  </span>
                </div>
              );
            })}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
